import { contains } from 'ramda';
import { combineReducers } from 'redux';
import { createSelector } from 'reselect';

import * as actions from '../actions';
// import { getBITemplateById } from './businessInformationTemplates';

// import initialState from './initialState';
// import { byId, withFieldsId } from './utils';

function byId(state = {}, action) {
  switch (action.type) {
    case actions.REQUEST_BUSINESSINFO_SUCCESS:
      return Object.assign({}, state, action.data.items.entities.businessInformations);
    case actions.REQUEST_BUSINESSINFO_ORDER_SUCCESS:
    case actions.UPDATE_BUSINESSINFO_NOTES_SUCCESS:
    case actions.UPDATE_BUSINESSINFO_STATUS_SUCCESS:
      return Object.assign({}, state, action.data.entities.businessInformations);
    case actions.REQUEST_ORDER_SUCCESS:
    case actions.PLACE_ORDER_NATIONAL_SUCCESS:
      return Object.assign({}, state, action.data.response.entities.businessInformations);
    default:
      return Object.assign({}, state);
  }
}

function ids(state = [], action) {
  switch (action.type) {
    case actions.REQUEST_BUSINESSINFO_SUCCESS:
      return action.data.items.result;
    case actions.REQUEST_BUSINESSINFO_ORDER_SUCCESS:
    case actions.UPDATE_BUSINESSINFO_NOTES_SUCCESS:
    case actions.UPDATE_BUSINESSINFO_STATUS_SUCCESS:
      return !contains(action.data.result, state)
        ? Object.assign([], state, [action.data.result])
        : Object.assign([], state);
    default:
      return Object.assign([], state);
  }
}

function loading(state = false, action) {
  switch (action.type) {
    case actions.REQUEST_BUSINESSINFO_START:
    case actions.REQUEST_BUSINESSINFO_ORDER_START:
    case actions.UPDATE_BUSINESSINFO_NOTES_START:
    case actions.UPDATE_BUSINESSINFO_STATUS_START:
      return true;
    case actions.REQUEST_BUSINESSINFO_SUCCESS:
    case actions.REQUEST_BUSINESSINFO_ERROR:
    case actions.REQUEST_BUSINESSINFO_ORDER_SUCCESS:
    case actions.REQUEST_BUSINESSINFO_ORDER_ERROR:
    case actions.UPDATE_BUSINESSINFO_NOTES_SUCCESS:
    case actions.UPDATE_BUSINESSINFO_NOTES_ERROR:
    case actions.UPDATE_BUSINESSINFO_STATUS_SUCCESS:
    case actions.UPDATE_BUSINESSINFO_STATUS_ERROR:
      return false;
    default:
      return state;
  }
}

function error(state = null, action) {
  switch (action.type) {
    case actions.REQUEST_BUSINESSINFO_START:
    case actions.REQUEST_BUSINESSINFO_SUCCESS:
    case actions.REQUEST_BUSINESSINFO_ORDER_START:
    case actions.REQUEST_BUSINESSINFO_ORDER_SUCCESS:
    case actions.UPDATE_BUSINESSINFO_NOTES_START:
    case actions.UPDATE_BUSINESSINFO_NOTES_SUCCESS:
    case actions.UPDATE_BUSINESSINFO_STATUS_START:
    case actions.UPDATE_BUSINESSINFO_STATUS_SUCCESS:
      return null;
    case actions.REQUEST_BUSINESSINFO_ERROR:
    case actions.REQUEST_BUSINESSINFO_ORDER_ERROR:
    case actions.UPDATE_BUSINESSINFO_NOTES_ERROR:
    case actions.UPDATE_BUSINESSINFO_STATUS_ERROR:
      return action.err.message || process.env.ERR_GENERIC;
    default:
      return state;
  }
}

function total(state = 0, action) {
  switch (action.type) {
    case actions.REQUEST_BUSINESSINFO_SUCCESS:
      return action.data.total;
    default:
      return state;
  }
}

const businessInformations = combineReducers({
  byId,
  ids,
  loading,
  error,
  total,
});

export default businessInformations;

export const $getIds = state => state.businessInformations.ids;
export const $getBusinessInformations = state => state.businessInformations.byId;
export const $getBusinessInformationById = (state, id) => state.businessInformations.byId[id];
export const $getBusinessInformationsByIds = (state, biIds) => (biIds || [])
  .map(id => state.businessInformations.byId[id]);
export const $getLoading = state => state.businessInformations.loading;
export const $getTotal = state => state.businessInformations.total;

export const getBusinessInformationById = (state, id) => state.businessInformations.byId[id];

export const getBusinessInformationsByIds = createSelector(
  $getBusinessInformationsByIds,
  $getBusinessInformations,
  $businessInformations => $businessInformations);

export const getTotal = createSelector(
  $getTotal,
  $total => $total);

export const getLoading = createSelector(
  $getLoading,
  $loading => $loading);
